import React from "react";
import LogoWhite from "../../Assets/images/logo_white.svg";
import ChatImg01 from "../../Assets/images/chat-img01.png";
import ChatCircleIcon from "../../Assets/svgs/ChatCircleIcon";
import SmallLogoIcon from "../../Assets/svgs/SmallLogoIcon";
import ChatBG from "../../Assets/images/chat-bg.png";
import Lottie from "lottie-react";
import lottieOrb from "../../Assets/lottie/lottie-orb.json";
import TalkAssistantIcon from "../../Assets/svgs/TalkAssistantIcon";

const StartTalk = ({ callData, onPressStart }) => {
  return (
    <section className="layoutContainer layoutContainer--full">
      <div className="layoutGrid">
        <div
          className="page page--loginOtp page--chatBg"
          style={{
            background: `url(${
              typeof callData?.assistantDetails?.webScreen === "string" &&
              callData?.assistantDetails?.webScreen?.length
                ? callData?.assistantDetails?.webScreen
                : ChatBG
            }) no-repeat`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        >
          <div className="page__head">
            <div className="page__head__logo">
              <img
                src={callData?.contactDetails?.customer?.logo ?? LogoWhite}
                alt="Logo | Vox App"
              />
            </div>
          </div>
          <div className="page__body">
            <div className="chatwrap" style={{ height: "auto" }}>
              <div className="chatwrap__head">
                {/* <h1 className="title title--h1">
                  The Smartest AI Assistant,
                  <br /> Ready to Chat!
                </h1>
                <p className="para">
                  Simplify tasks, automate routines, and enjoy personalized
                  interactions—all in one chat.
                </p> */}
              </div>
              <div className="chatwrap__body">
                <div className="chatCircle">
                  {/* <img className="chatCircle__img" src={ChatImg01} alt="" /> */}
                </div>
                <div className="chatCircleAction" onClick={onPressStart}>
                  <span className="icon">
                    <Lottie
                      animationData={lottieOrb}
                      loop={true}
                      width={300}
                      height={300}
                    />
                    <div className="chatCircleAction__wrapper">
                      {callData?.assistantDetails?.avatar ? (
                        <img
                          className="chatCircleAction__wrapper__img"
                          src={callData?.assistantDetails?.avatar}
                        />
                      ) : (
                        <div
                          className="chatCircleAction__wrapper__img"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#fff",
                          }}
                        >
                          <TalkAssistantIcon />
                        </div>
                      )}
                    </div>
                  </span>
                  <button className="link">
                    Click on image to start the chat
                  </button>
                </div>
              </div>
              <div className="chatwrap__footer">
                <p className="para">
                  <SmallLogoIcon />
                  <a
                    style={{ color: "#fff" }}
                    href="http://www.voxapp.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Powered By VoxApp
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartTalk;
